import React from "react";
import moment from "moment";
import { getRelationshipText } from "../helpers";
import { translationService } from "../utils/translationService";

function SideComment(props) {
    const comment = props.comment;
    const map = props.map;
    const latlng = props.latlng;
    const point = props.point;

    // Track viewport visibility for translation
    React.useEffect(() => {
        const observer = translationService.initializeViewportObserver();
        const element = document.querySelector(`[data-comment-id="${comment.id}"]`);
        
        if (observer && element) {
            observer.observe(element);
            return () => observer.disconnect();
        }
    }, [comment.id]);

    function filterLayers(layers, id) {
        return layers.filter(function (layer) {
            if (layer.options) {
                return layer.options.id === id;
            } else {
                return false;
            }
        });
    }

    function commentClick() {
        // Close the panel on mobile (width <= 600px) so users can see the comment on the map
        if (window.innerWidth <= 600 && props.closePanel) {
            props.closePanel();
        }

        const mapElement = map.leafletElement;
        const container = mapElement.getContainer();
        const height = container.offsetHeight;

        mapElement.setView(latlng, 18);
        // Position the pin at 1/4 from the bottom of the screen
        mapElement.panBy([0, -height / 4]);

        setTimeout(() => {
            const id = comment.id;

            let layers = Object.values(mapElement._layers);
            let layer = filterLayers(layers, id);
            layer = layer[0];

            if (layer) {
                mapElement.setView(layer.getLatLng(), 18);
                layer.openPopup();
                // Position the pin at 1/4 from the bottom of the screen
                mapElement.panBy([0, -height / 4]);
            }
            mapElement.setView(latlng, 18);
            // Position the pin at 1/4 from the bottom of the screen
            mapElement.panBy([0, -height / 4]);
        }, 300);
    }

    const typeLabel = {
        "dream": "Dream",
        "dreams_2": "Dream",
        "place": "Special Place",
        "issue": "Issue"
    };

    // Get category and type - prefer point data over comment data (point is always accurate)
    const category = (point && point.category) || comment.category || "general";
    const type = (point && point.type) || comment.type || "place";
    // Normalize dreams_2 to dream for icon lookup
    const normalizedType = type === "dreams_2" ? "dream" : type;
    // For "general" category, use "pin_" prefix instead of "general_"
    const iconUrl = category === "general" 
        ? `/icons/pin_${normalizedType}.svg`
        : `/icons/${category}_${normalizedType}.svg`;

    return (
        <div
            className="sideComment"
            data-id={comment.id}
            data-comment-id={comment.id}
            onClick={commentClick}
        >
            <h3 className="commentType">
                <img
                    className="icon"
                    alt=""
                    src={iconUrl}
                    style={{ width: "24px", height: "24px", marginRight: "8px" }}
                />
                {category.charAt(0).toUpperCase() + category.slice(1)}: {typeLabel[type] || "Comment"}
            </h3>
            <div className="comment">
                <h3 className="commentContent">{comment.comment || comment.text || "No text"}</h3>
                <p className="commentBy">
                    {"by "}
                    {(comment.commentBy || comment.name || "Anonymous").split(" ")[0]}
                </p>
                <p className="commentDate">
                    {comment.submittedOn ? moment(comment.submittedOn).fromNow() : "Date unknown"}
                </p>
                <p className="commentAbout">
                    {getRelationshipText(
                        comment.live,
                        comment.work,
                        comment.visit
                    )}
                </p>
            </div>
        </div>
    );
}

export default SideComment;
